<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div
    data-testid="sales-delivery-summary-rank-skeleton"
    class="grid gap-4"
    role="status"
    aria-live="polite"
    aria-busy="true"
    :aria-label="t('SALES.DELIVERY.SUMMARY.LOADING')"
  >
    <section
      data-testid="sales-delivery-summary-rank-skeleton-card"
      class="rounded-lais border border-lais-border-soft bg-white p-5 sm:p-8 xl:px-11"
    >
      <div class="h-9 w-44 animate-pulse rounded bg-lais-bg-muted" />
      <div
        class="mt-2 h-8 w-full max-w-[480px] animate-pulse rounded bg-lais-bg-muted"
      />
      <div
        class="mt-3 h-6 w-full max-w-[1070px] animate-pulse rounded bg-lais-bg-muted"
      />
      <div
        class="mt-2 h-6 w-4/5 max-w-80 animate-pulse rounded bg-lais-bg-muted"
      />
    </section>

    <section
      data-testid="sales-delivery-summary-rank-skeleton-card"
      class="min-h-[28.75rem] rounded-lais border border-lais-border-soft bg-white p-5 sm:p-8 xl:px-10"
    >
      <div
        class="h-8 w-full max-w-[1070px] animate-pulse rounded bg-lais-bg-muted"
      />
      <div
        class="mt-6 h-8 w-3/5 max-w-[280px] animate-pulse rounded bg-lais-bg-muted"
      />
      <div class="mt-5 grid gap-3">
        <div
          v-for="line in 4"
          :key="line"
          class="h-6 w-4/5 max-w-[660px] animate-pulse rounded bg-lais-bg-muted"
        />
      </div>
    </section>
  </div>
</template>
